import React, { useEffect, useState } from 'react'
import { Button, Dialog, DialogActions, DialogContent, Paper, PaperProps } from '@material-ui/core'
import Draggable from 'react-draggable';
import Alert from '@material-ui/lab/Alert/Alert';

import { ResponsableLegal } from '../../view/PortalPostulante/DatosPersonales/ResponsableLegal';
import IViewRepresentanteLegal from '../../view-interfaces/IViewTipoPersona'

import IViewGenero from '../../view-interfaces/IViewGenero';
import IViewGeneroCmb from '../../view-interfaces/IViewGeneroCmb';
import IViewComunas from '../../view-interfaces/IViewComunas';
import IViewComunasAuto from '../../view-interfaces/IViewComunasAuto';
import IViewPaisNacionalidad from '../../view-interfaces/IViewPaisNacionalidad';
import IViewPaisNacionalidadCmb from '../../view-interfaces/IViewPaisNacionalidadCmb';
import CheckCircleOutline from '@material-ui/icons/CheckCircleOutline'
import { ObtieneGeneroLogic, ObtieneComunaLogic, ObtienePaisNacionalidadLogic } from '../Combos/Combos.logic';

type Props = {
    estado: boolean;
    onClick: any;
    responsableLegal: IViewRepresentanteLegal[];
    rutPostulante: number;
    codigoNegocio: number;
    carrera: string;
    anioPromocion: number;
    periodoPromocion: number;
    validado_: boolean;
}

function PaperComponent(props: PaperProps) {
    return (
        <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
            <Paper {...props} />
        </Draggable>
    );
}

const DatosResponsableLegal: React.FC<Props> = ({ estado, onClick, responsableLegal, rutPostulante, codigoNegocio, carrera, anioPromocion, periodoPromocion, validado_ }) => {
    const [mnj, setMnj] = useState("Se ha guardado correctamente la información.");
    const [open, setOpen] = useState(false);
    const [paso, setPaso] = useState(false);
    const [validar, setValidar] = useState(false);
    const [guardar, setGuardar] = useState(false);

    const [validado, setValidado] = useState(false);
    const [guardado, setGuardado] = useState(validado_);

    const listaRL: Array<IViewRepresentanteLegal> = [];
    const [representanteLegal, setRepresentanteLegal] = useState(listaRL);

    const _genero: Array<IViewGenero> = [];
    const [listaGenero, setListaGenero] = useState(_genero);
    const _generoCmb: Array<IViewGeneroCmb> = [];
    const [listaGeneroCmb, setListaGeneroCmb] = useState(_generoCmb);

    const _comunas: Array<IViewComunas> = [];
    const [listaComunas, setListaComunas] = useState(_comunas);
    const _comunasAuto: Array<IViewComunasAuto> = [];
    const [listaComunasAuto, setListaComunasAuto] = useState(_comunasAuto);

    const _paisNacionalidad: Array<IViewPaisNacionalidad> = [];
    const [listaPaisNacionalidad, setListaPaisNacionalidad] = useState(_paisNacionalidad);
    const _paisNacionalidadCmb: Array<IViewPaisNacionalidadCmb> = [];
    const [listaPaisNacionalidadCmb, setListaPaisNacionalidadCmb] = useState(_paisNacionalidadCmb);

    const [mjeErrorAlerta, setMjeErrorAlerta] = useState('');

    const handleClose = () => { setOpen(false); };
    const handleLimpiar = () => { }

    const selListaGenero = (error: Boolean, err: string, Genero: IViewGenero[], _Genero: IViewGeneroCmb[]) => {
        try {
            if (error === false && Genero.length > 0) {
                setListaGenero(Genero);
                setListaGeneroCmb(_Genero);
            }
        } catch (er) {
            console.log('er', er);
        }
    }

    const selListaComunas = (error: Boolean, err: string, Comunas: IViewComunas[], _Comunas: IViewComunasAuto[]) => {
        try {
            if (error === false && Comunas.length > 0) {
                setListaComunas(Comunas);
                setListaComunasAuto(_Comunas);
            }
        } catch (er) {
            console.log('er', er);
        }
    }

    const selListaPaisNacionalidad = (error: Boolean, err: string, PaisNacionalidad: IViewPaisNacionalidad[], _PaisNacionalidad: IViewPaisNacionalidadCmb[]) => {
        try {
            if (error === false && PaisNacionalidad.length > 0) {
                setListaPaisNacionalidad(PaisNacionalidad);
                setListaPaisNacionalidadCmb(_PaisNacionalidad);
            }
        } catch (er) {
            console.log('er', er);
        }
    }

    const handleCargaGenero = () => {
        ObtieneGeneroLogic(selListaGenero);
    }

    const handleCargaComunas = () => {
        ObtieneComunaLogic(selListaComunas, codigoNegocio);
    }

    const handleCargaPaisNacionalidad = () => {
        ObtienePaisNacionalidadLogic(selListaPaisNacionalidad, codigoNegocio);
    }

    const handleValidarPopupDRL = (validado: boolean = false, mnsj: string = '', guardado: boolean = false) => {
        setValidado(validado);
        setValidar(false);
        setGuardar(false);
        setMjeErrorAlerta(mnsj);
        setGuardado(guardado);
    }

    const handleValidarDatos = () => {
        setValidar(true);
    }
    const handleGrabarDatos = () => {
        setGuardar(true);
    }

    useEffect(() => {
        handleCargaGenero();
        handleCargaComunas();
        handleCargaPaisNacionalidad();
        setRepresentanteLegal(responsableLegal);
    }, [])

    return (
        <>
            <Dialog open={estado}
                onClose={handleClose}
                PaperComponent={PaperComponent}
                fullWidth={true}
                aria-labelledby="draggable-dialog-title">
                {/* <DialogTitle  id="draggable-dialog-title">Datos Representante Legal</DialogTitle> */}
                <DialogContent>
                    <ResponsableLegal
                        codigoNegocio={codigoNegocio}
                        rutPostulante={rutPostulante}
                        carrera={carrera}
                        anioPromocion={anioPromocion}
                        periodoPromocion={periodoPromocion}
                        representanteLegal={responsableLegal}
                        listaGenero={listaGeneroCmb}
                        listaComunas={listaComunasAuto}
                        listaPaisNacionalidad={listaPaisNacionalidadCmb}
                        callback={handleValidarPopupDRL}
                        validar={validar}
                        guardar={guardar}
                    />
                </DialogContent>
                <DialogActions>
                    {mjeErrorAlerta === '' ? "" : mjeErrorAlerta === 'Guardando...' ? mjeErrorAlerta : guardado ? <Alert variant="outlined"
                        /* icon={<CheckIcon fontSize="inherit" />} */
                        iconMapping={{
                            info: <CheckCircleOutline fontSize="inherit" />,
                        }}
                        severity="info">{mjeErrorAlerta}</Alert> : <Alert variant="outlined" severity={"warning"}>{mjeErrorAlerta}</Alert>}
                    {/*  <Button onClick={handleValidarDatos} disabled={validado} variant="contained" color="primary">Validar</Button> */}
                    &nbsp;&nbsp;&nbsp;
                    <Button onClick={handleGrabarDatos} disabled={mjeErrorAlerta === 'Guardando...' ? true : false} variant="contained" color="primary">Validar</Button>
                    &nbsp;&nbsp;&nbsp;
                    <Button autoFocus onClick={() => {
                        setTimeout(() => {
                            onClick(paso, mjeErrorAlerta === '' ? validado_ : guardado)
                        }, 1000);
                    }} color="primary" disabled={mjeErrorAlerta === 'Guardando...' ? true : false} onBlur={handleLimpiar}>Salir</Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default DatosResponsableLegal;
